import React from "react";
import {
  Box,
  Eye,
  GraduationCap,
  CheckCircle,
  Activity,
  Shield,
  Cloud,
  Settings,
  Users,
  Zap,
  ChevronRight,
  Menu,
  X,
  Award,
  Lock,
  Globe,
} from "lucide-react";

const Whyus = () => {
  return (
    <section id="why-us" className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Why Choose Beebox 3D?
          </h2>
          <p className="text-lg text-gray-600">
            Trusted by enterprises for innovation and reliability
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Side */}
          <div className="space-y-8">
            {[
              {
                icon: <Award className="w-6 h-6 text-yellow-500" />,
                title: "IIT Madras Incubated",
                desc: "Born from academic excellence with cutting-edge R&D capabilities",
              },
              {
                icon: <Zap className="w-6 h-6 text-yellow-500" />,
                title: "Proven Track Record",
                desc: "Years of experience delivering custom 3D solutions for enterprises",
              },
              {
                icon: <Cloud className="w-6 h-6 text-yellow-500" />,
                title: "Flexible & Adaptable",
                desc: "We evolve with your needs - custom integrations available",
              },
              {
                icon: <Lock className="w-6 h-6 text-yellow-500" />,
                title: "Trust Built Over Time",
                desc: "Start small and expand confidently",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-4 rounded-xl hover:bg-white hover:shadow-md transition"
              >
                <div className="mt-1">{item.icon}</div>
                <div>
                  <h3 className="text-lg font-semibold text-black mb-1">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Card */}
          <div className="bg-white rounded-3xl p-10 shadow-2xl border border-yellow-400">
            <h3 className="text-2xl font-bold text-black mb-8">
              Our Recommended Approach
            </h3>

            <div className="space-y-6">
              {[
                "Start with SalesBee - no confidential data needed",
                "We create custom content and onboard your team",
                "Build trust and see ROI quickly",
                "Expand to other products as your needs grow",
              ].map((step, index) => (
                <div key={index} className="flex items-center space-x-4">
                  <div className="w-9 h-9 bg-yellow-400 rounded-full flex items-center justify-center font-bold">
                    {index + 1}
                  </div>
                  <p className="text-gray-700 text-sm">{step}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Whyus;
